import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { useState as k, useCallback as v } from "react";
import { usePreventScroll as P } from "react-aria";
import { useLayoutEffect as x } from "@react-aria/utils";
import g from "classnames";
import S from "../../assets/icons/menu.svg.js";
import O from "../../assets/icons/close.svg.js";
import d from "../Button/Button.js";
import { Root as D, List as I, Item as f, Trigger as y, Content as C } from "./NavigationMenuPrimitive.js";
import N from "../../assets/logo-mashvisor.svg.js";
import { createMenuContentData as T } from "./helpers.js";
import b from "./NavMenuContent.js";
import V from "../../hooks/useMedia.js";
import { initEventHandler as $ } from "./tracking/events.js";
import o from "./Nav.module.scss.js";
var j = function j() {
    var _k = k(!1),
      _k2 = _slicedToArray(_k, 2),
      a = _k2[0],
      m = _k2[1],
      c = V("(max-width: 1024px)", !1);
    P({
      isDisabled: !a
    });
    var i = v(function () {
        m(!0);
      }, []),
      u = v(function () {
        m(!1);
      }, []);
    x(function () {
      c || u();
    }, [c]), x(function () {
      var t = document.body.style.getPropertyValue("overflow-x"),
        p = document.body.style.getPropertyPriority("overflow-x");
      return a && document.body.style.setProperty("overflow-x", "unset", "important"), function () {
        a && document.body.style.setProperty("overflow-x", t, p);
      };
    }, [a]);
    var h = v(function () {
      m(function (t) {
        return !t;
      });
    }, []);
    return {
      open: i,
      close: u,
      toggle: h,
      isOpen: a,
      isMobile: c
    };
  },
  X = function X(_ref) {
    var a = _ref.onDemoClick,
      m = _ref.onContactSupportClick,
      c = _ref.customerPlan,
      _ref$baseOrigin = _ref.baseOrigin,
      i = _ref$baseOrigin === void 0 ? "" : _ref$baseOrigin;
    var _k3 = k(""),
      _k4 = _slicedToArray(_k3, 2),
      u = _k4[0],
      h = _k4[1],
      t = j(),
      p = t.isOpen,
      n = t.isMobile,
      L = function L() {
        h("");
      },
      M = function M() {
        n || L();
      },
      l = $({
        isLoggedIn: c !== "VISITOR"
      }),
      s = T({
        onDemoClick: function onDemoClick() {
          M(), a();
        },
        onContactSupportClick: function onContactSupportClick() {
          M(), m();
        },
        baseOrigin: i,
        eventHandler: l
      }),
      w = i || "/";
    return /* @__PURE__ */r(D, {
      value: u,
      isMobile: n,
      onValueChange: h,
      className: g(o.root, _defineProperty({}, o.open, t.isOpen)),
      "data-mv-user-plan": c,
      "data-cy": "Navigation",
      children: [/* @__PURE__ */r("div", {
        className: g(o.mobileContainer, _defineProperty({}, o.open, t.isOpen)),
        children: [/* @__PURE__ */e("a", {
          href: w,
          className: o.imageMobileContainer,
          onClick: function onClick() {
            return l({
              category: "main",
              action: "Logo"
            });
          },
          children: /* @__PURE__ */e(N, {
            width: 151,
            height: 32
          })
        }), /* @__PURE__ */e("div", {
          className: o.mobileButtonContainer,
          children: /* @__PURE__ */e(d, {
            variant: "icon",
            testId: "MobileMenuToggle",
            onClick: function onClick() {
              t.toggle();
            },
            children: t.isOpen ? /* @__PURE__ */e(O, {}) : /* @__PURE__ */e(S, {})
          })
        })]
      }), /* @__PURE__ */r("header", {
        className: g([o.container, n && o.containerMb, p && o.menuOpen]),
        children: [/* @__PURE__ */e("a", {
          href: w,
          className: o.imageContainer,
          onClick: function onClick() {
            return l({
              category: "main",
              action: "Logo"
            });
          },
          children: /* @__PURE__ */e(N, {
            width: 151,
            height: 32
          })
        }), /* @__PURE__ */r(I, {
          className: g([o.navContainer, p && o.menuOpen]),
          children: [/* @__PURE__ */r(f, {
            className: o.item_overview,
            value: "product",
            children: [/* @__PURE__ */e(y, {
              href: s.productOverview.mainLink,
              children: "Product"
            }), /* @__PURE__ */e(C, {
              children: /* @__PURE__ */e(b, {
                content: s.productOverview
              })
            })]
          }), /* @__PURE__ */e(f, {
            className: o.item_pricing,
            value: "pricing",
            children: /* @__PURE__ */e(d, {
              href: "".concat(i, "/pricing"),
              variant: "text",
              marginStart: n ? -8 : 0,
              marginTop: n ? 10 : 0,
              marginBottom: n ? 10 : 0,
              width: n ? "100%" : "auto",
              justify: "start",
              alignSelf: "start",
              poppinsFont: !0,
              underline: !1,
              height: "full",
              color: "geekblue-800",
              onClick: function onClick() {
                return l({
                  category: "main",
                  action: "Pricing"
                });
              },
              children: "Pricing"
            })
          }), /* @__PURE__ */r(f, {
            value: "resources",
            children: [/* @__PURE__ */e(y, {
              href: s.resources.mainLink,
              children: "Resources"
            }), /* @__PURE__ */e(C, {
              children: /* @__PURE__ */e(b, {
                content: s.resources
              })
            })]
          }), /* @__PURE__ */r(f, {
            value: "guides",
            children: [/* @__PURE__ */e(y, {
              href: s.resources.mainLink,
              children: "Guides & Trends"
            }), /* @__PURE__ */e(C, {
              children: /* @__PURE__ */e(b, {
                content: s.guides,
                collapsible: !0
              })
            })]
          })]
        }), /* @__PURE__ */r("div", {
          className: o.headerActions,
          children: [/* @__PURE__ */e("div", {
            className: o.headerActionsLogged,
            children: /* @__PURE__ */e(d, {
              href: "".concat(i, "/explore/dashboard"),
              onClick: function onClick() {
                return l({
                  category: "main",
                  action: "Dashboard"
                });
              },
              flex: n ? 1 : "revert",
              children: "Go to Dashboard"
            })
          }), /* @__PURE__ */r("div", {
            className: o.headerActionsVisitors,
            children: [/* @__PURE__ */e(d, {
              href: "".concat(i, "/auth"),
              variant: n ? "outline" : "text",
              withoutPadding: !0,
              marginEnd: 24,
              rel: "nofollow",
              onClick: function onClick() {
                l({
                  category: "main",
                  action: "Login"
                });
              },
              flex: n ? 1 : "revert",
              children: "Login"
            }), /* @__PURE__ */e(d, {
              rounding: "full",
              href: "".concat(i, "/signup"),
              rel: "nofollow",
              color: "light-green",
              onClick: function onClick() {
                l({
                  category: "main",
                  action: "SignUp"
                });
              },
              flex: n ? 1 : "revert",
              children: "Sign Up"
            })]
          })]
        })]
      })]
    });
  };
export { X as default };